import { of, EMPTY, concat } from 'rxjs';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import Global from '../../../store/global-selectors';
import get from 'lodash.get';
import {
  updateShipmentConfigurationPackagesFromPreset,
  updateShipmentConfigurationOptions,
  updateShipmentConfiguration,
  changeInsuredValue,
} from '../../../store/csw/csw.actions';
import { presetService } from '../../../services/preset-service';
import { InsuranceValues } from '../../../enums/insurance-values';
import { setModel } from '../../../store/bulk/update/bulk.update.actions';
import { setConfirmationTypes$ } from '../../../store/bulk/update/bulk.update.observables';
import { bulkUpdateRequestFromDrawer$ } from '../../../store/bulk/update/bulk.update.request.observables';
import { BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID } from '../../../store/orders/drawer/constants';

export const getSingleOrMultiSelectionPresetObservables = (action, getState) => {
  const state = getState();
  const { fulfillmentPlanIds = emptyArray, callbackWithPayload } = action;
  const [fulfillmentPlanId] = fulfillmentPlanIds;
  const hasMultipleGridSelections = fulfillmentPlanIds.length > 1;

  if (!fulfillmentPlanId && !hasMultipleGridSelections) {
    // TODO: handle error case
    return EMPTY;
  }

  const { hotkey } = action;
  const services = Global.selectSellerServices(state) || emptyArray;
  const sellerLabelProviders = Global.selectSellerLabelProviders(state);
  const sellerShipFroms = Global.selectSellerShipFroms(state) || emptyArray;
  const presets = Global.selectSellerPresets(state) || emptyArray;
  const presetIndex = presets.findIndex((preset) => preset.hotKey === hotkey);
  if (presetIndex > -1) {
    const preset = presets[presetIndex];

    // Package mapping when applied directly
    const storePackages = Global.selectSellerPackages(state) || emptyArray;
    const payload = presetService.generateHotkeyConfigPayload(preset, storePackages, services, sellerLabelProviders, sellerShipFroms);
    const observables = [];
    const { options } = payload;
    if (hasMultipleGridSelections) {
      const model = {
        shippingConfiguration: {
          ...payload.presetOptions,
          packages: payload.packages,
          options,
        },
      };
      const presetJob = Global.selectBulkUpdateBulkUpdateJob(getState(), {
        bulkUpdateJobId: BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID,
      });
      const updatedJob = {
        ...presetJob,
        model,
      };
      return concat(
        of(setModel(BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID, model)),
        setConfirmationTypes$(BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID, model, getState),
        bulkUpdateRequestFromDrawer$(getState, action, updatedJob),
      );
    }

    if (get(payload, 'packages', emptyArray).length) {
      observables.push(of(updateShipmentConfigurationPackagesFromPreset(fulfillmentPlanId, ...get(payload, 'packages', emptyObject))));
    }
    if (options) {
      if (options?.confirmation?.confirmationId) {
        const clonedConfirmation = { ...options.confirmation };
        options.confirmation = clonedConfirmation.confirmationId;
        options.confirmationEnumId = clonedConfirmation.confirmationId;
      }
      Object.keys(options).forEach((option) => {
        observables.push(of(updateShipmentConfigurationOptions(fulfillmentPlanId, option, options[option])));
      });
    }
    if (get(payload, 'presetOptions') && Object.keys(get(payload, 'presetOptions')).length) {
      observables.push(of(updateShipmentConfiguration(fulfillmentPlanId, payload.presetOptions)));
      if (get(payload, 'presetOptions.insuranceProvider')) {
        const insuranceValue = InsuranceValues.Sum.name;
        observables.push(of(changeInsuredValue(fulfillmentPlanId, insuranceValue)));
      }
    }

    if (callbackWithPayload) {
      callbackWithPayload(payload);
    }

    return concat(...observables);
  }

  // TODO: handle error case - is there really an error case for this?
  return EMPTY;
};
